// src/pages/PrivacyPolicy.jsx
import { Box, Container, Typography, Stack, Card, CardContent, Divider } from "@mui/material";

export default function PrivacyPolicy() {
  return (
    <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "background.default" }}>
      <Container maxWidth="md">
        <Stack spacing={2} sx={{ textAlign: "center", mb: { xs: 3, md: 5 } }}>
          <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
            Legal
          </Typography>
          <Typography variant="h4" fontWeight={800}>Privacy Policy</Typography>
          <Typography color="text.secondary">Last updated: August 24, 2025</Typography>
        </Stack>

        <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 3 }}>
          <CardContent sx={{ p: { xs: 3, md: 4 } }}>
            <Stack spacing={3}>
              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  1. What information we collect
                </Typography>
                <Typography color="text.secondary">
                  We currently do not collect, store, or process any personal information (PII) via this website.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  2. Cookies & similar technologies
                </Typography>
                <Typography color="text.secondary">
                  We do not set analytics or advertising cookies at this time. If this changes, we will update this Policy,
                  provide a cookie notice/consent, and describe the categories and purposes.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  3. Third‑party links & affiliate programs
                </Typography>
                <Typography color="text.secondary">
                  Our website may contain affiliate links to third‑party platforms (e.g., Amazon, Flipkart, Nykaa).
                  If you purchase via such links, we may earn a commission at no extra cost to you.
                  Those platforms may collect data per their own privacy policies, which we do not control.
                  Please review their policies before using their services.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  4. Images, logos & brand materials
                </Typography>
                <Typography color="text.secondary">
                  Product images, posters, logos, and trademarks on this website are the property of their respective owners.
                  We do not host original files. Any commercial use or redistribution by any person requires prior permission
                  from the original owner/brand.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  5. Children’s privacy
                </Typography>
                <Typography color="text.secondary">
                  Our website is not intended for users under 18. We do not knowingly collect personal data from children.
                  If you believe a child has provided us data, please contact us.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  6. Data retention
                </Typography>
                <Typography color="text.secondary">
                  We do not retain personal data. If our practices change, we will describe retention and deletion timelines here.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  7. Data security
                </Typography>
                <Typography color="text.secondary">
                  Although we currently do not process personal data, we maintain reasonable technical and organizational
                  measures to protect our website infrastructure.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  8. Your rights (India)
                </Typography>
                <Typography color="text.secondary">
                  If we begin processing personal data, users in India may have rights under applicable law, including the
                  Digital Personal Data Protection Act, 2023 (DPDP Act)—such as access, correction, and deletion—subject to legal limits.
                  We will publish procedures to exercise these rights if data collection begins.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  9. Changes to this Policy
                </Typography>
                <Typography color="text.secondary">
                  We may update this Policy from time to time. Changes take effect when posted here with an updated date.
                </Typography>
              </section>

              <Divider />

              <section>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                  10. Contact us
                </Typography>
                <Typography color="text.secondary">
                  For questions about this Policy, contact: <strong>support@cosmeticompare.com</strong><br />
                  Jurisdiction: Bengaluru, Karnataka, India
                </Typography>
              </section>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
